import Icon, { CloseCircleFilled, FileOutlined } from '@ant-design/icons';
import { Flex } from 'antd';
import React from 'react';
import CustomAttachmentImageIcon from '~/assets/svg/icon-attachment-image.svg?react';
import CustomAttachmentPdfIcon from '~/assets/svg/icon-attachment-pdf.svg?react';

const isFileImage = (fileType) => fileType.match('image.*');
const isFilePdf = (fileType) => fileType === 'application/pdf';

export function getFileIconForAttachment(fileType) {
  if (isFileImage(fileType)) {
    return <Icon className='text-2xl' component={CustomAttachmentImageIcon} />;
  }
  if (isFilePdf(fileType)) {
    return <CustomAttachmentPdfIcon className='text-2xl' />;
  }
  return <FileOutlined className='text-2xl' />;
}

function AttachmentPreview({ files, onRemoveFile, className = '' }) {
  if (!files.length) return null;

  return (
    <Flex gap={10} align='center' className={`self-start overflow-auto ${className}`}>
      {files.map((file) => (
        <Flex key={file.name} title={file.name} gap={4} vertical className='w-[60px]'>
          <div className='rounded-sm bg-lila-background h-[60px] relative flex justify-center items-center'>
            {getFileIconForAttachment(file.type)}
            <span className='absolute top-0 right-0.5 cursor-pointer' onClick={() => onRemoveFile(file.name)}>
              <CloseCircleFilled />
            </span>
          </div>
          <p className='caption1 text-grey-medium text-ellipsis whitespace-nowrap overflow-hidden'>{file.name}</p>
        </Flex>
      ))}
    </Flex>
  );
}

export default AttachmentPreview;
